import { THRUST_AREAS } from "@/data/content";
import Reveal from "@/components/Reveal";
import { ArrowUpRight } from "lucide-react";

export default function ThrustAreas() {
  return (
    <section id="thrust" className="py-24 sm:py-32 px-5 sm:px-8 lg:px-12 bg-ink text-white">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-crimson font-semibold mb-5">02 · Thrust Areas</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[0.95] max-w-3xl">
            Fourteen frontiers, one conference.
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/15">
          {THRUST_AREAS.map((area, i) => (
            <Reveal key={area} delay={(i % 4) * 0.06}>
              <div className="group border-r border-b border-white/15 p-6 sm:p-7 h-full flex flex-col justify-between hover:bg-crimson transition-colors duration-300 min-h-[170px]">
                <span className="font-mono text-xs text-white/40 group-hover:text-white/80 transition-colors">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="mt-6 flex items-end justify-between gap-3">
                  <h3 className="font-heading text-lg sm:text-xl font-medium leading-snug">{area}</h3>
                  <ArrowUpRight size={18} className="shrink-0 text-white/30 group-hover:text-white transition-colors" />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
